<template>
  <el-form-item :label="label" :required="required">
    <el-select
      v-model="formData"
      :disabled="disabled"
      :placeholder="placeholder"
      value-key="value"
      @change="updated">

      <el-option
      v-for="item in items"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>

    </el-select>
  </el-form-item>
</template>

<script>

export default {
  name: 'select-action-type',

  props: {
    label: {
      type: String,
      default: 'Action Type'
    },
    value: {
//      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    },
    helpText: {
      type: String,
      default: null
    }
  },

  methods: {
    updated (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  },

  data () {
    return {
      formData: this.value,
      items: this.getConfig().selects.actionType
    }
  }
}
</script>



// WEBPACK FOOTER //
// SelectActionType.vue?66035408